import _ from 'lodash';
import { List, Map, fromJS } from 'immutable';
import StoreConstants from '../constants/StoreConstants';
import PaginatedStore from './PaginatedStore';
import Store from '../models/Store';
import StoreFeed from '../models/StoreFeed';

class StoreStore extends PaginatedStore {
  static storeName = 'StoreStore';
  static handlers = {
    [StoreConstants.FETCH_STORE_START]        :  'fetchEntityStart',
    [StoreConstants.FETCH_STORE_SUCCESS]      :  'fetchEntitySuccess',
    [StoreConstants.FETCH_STORE_FAILURE]      :  'fetchEntityFailure',
    [StoreConstants.LIST_STORES_START]        :  'listEntitiesStart',
    [StoreConstants.LIST_STORES_SUCCESS]      :  'listEntitiesSuccess',
    [StoreConstants.LIST_STORES_FAILURE]      :  'listEntitiesFailure',
    [StoreConstants.SET_CURRENT_STORE]        :  'setCurrentEntity',
    [StoreConstants.FETCH_STORE_FEED_START]   : 'fetchStoreFeedStart',
    [StoreConstants.FETCH_STORE_FEED_SUCCESS] : 'fetchStoreFeedSuccess',
    [StoreConstants.FETCH_STORE_FEED_FAILURE] : 'fetchStoreFeedFailure'
  };
  static defaultPagination = { offset: 0, limit: 30 };
  static defaultSorter = { key: 'name', direction: 'asc' };
  static entityModel = Store;

  constructor(dispatcher) {
    super(dispatcher);

    this.feedsBySlug = new Map();
    this.storesBySlug = new Map();
  }

  fetchStoreFeedStart(data) {
    // Clear for the provided id/slug
    // this.feedsBySlug = this.feedsBySlug.delete(data.slug);
    this.emitChange();
  }

  fetchStoreFeedSuccess(data) {
    this.feedsBySlug = this.feedsBySlug.set(data.slug, data.storeFeed);
    this.emitChange();
  }

  fetchStoreFeedFailure(data) {
    console.log(`Error fetching feed: `, data.error);
    this.logError(data.error);
  }

  fetchEntitySuccess(store) {
    this.storesBySlug = this.storesBySlug.set(store.slug, store);
    super.fetchEntitySuccess(store);
  }

  listEntitiesSuccess(data) {
    if(!_.isEqual(data.sorter, this.currentSorter) || !_.isEqual(data.filters, this.currentFilters)) {
      return;
    }

    data.entities.forEach((store) => {
      this.storesBySlug = this.storesBySlug.set(store.slug, store);
    });

    super.listEntitiesSuccess(data);
  }

  getCurrentStore() {
    return this.getCurrentEntity(arguments);
  }

  getStoreBySlug(slug) {
    return this.storesBySlug.get(slug);
  }

  getFeedBySlug(slug) {
    return this.feedsBySlug.get(slug);
  }

  getCurrentFeed() {
    let currentStore = this.getCurrentEntity();
    if(!currentStore) {return new List();}
    let slug = currentStore.slug;
    return this.feedsBySlug.get(slug);
  }

  dehydrate() {
    return _.extend(super.dehydrate(), {
      feedsBySlug: this.feedsBySlug.toJS()
    });
  }

  rehydrate(state) {
    super.rehydrate(state);
    this.feedsBySlug = _.reduce(state.feedsBySlug, (map, storeFeed, slug) => {
      return map.set(slug, new StoreFeed(storeFeed));
    }, new Map());
    this.entities.forEach((store) => {
      this.storesBySlug = this.storesBySlug.set(store.slug, store);
    });
  }
}

export default StoreStore;



// WEBPACK FOOTER //
// banquet/stores/StoreStore.js